import {useCallback, useEffect, useState} from "react";

enum SizeScreen {
    tablet = 1179,
    mobile = 767,
}

enum ImageHeight {
    desktop = '90vh',
    tablet = '84vw',
    mobile = '110vw',
}

export const useResize = () => {
    const [baseHeight, setBaseHeight] = useState('0');

    const resizeWindow = useCallback(() => {
        const isDesktop = window.innerHeight <= window.innerWidth;
        const isTablet = window.innerWidth <= SizeScreen.tablet && !isDesktop;
        const isMobile = window.innerWidth <= SizeScreen.mobile;

        if (isDesktop) {
            setBaseHeight(ImageHeight.desktop);
        }
        if (isTablet) {
            setBaseHeight(ImageHeight.tablet);
        }
        if (isMobile) {
            setBaseHeight(ImageHeight.mobile);
        }
    }, []);

    useEffect(() => {
        resizeWindow();
        window.addEventListener('resize', resizeWindow, false);

        return () => {
            window.removeEventListener('resize', resizeWindow);
        }
    }, [resizeWindow]);

    return {
        baseHeight,
    }
};
